(function () {
    'use strict';

    angular.module("imApp").factory("saftMainGroupsService", [function () {
        let service = {};

        return service;
    }]);
})();
